/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import '@fontsource/roboto';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { createTheme, Theme } from '@mui/material';
import { gray } from './colors';
import * as colors from './colors/index';
import { qtmTypography } from './typography';

export const qtmDarkTheme: Theme = createTheme({
  palette: {
    common: {
      black: colors.common.black,
      white: colors.common.white,
    },
    mode: 'dark',
    primary: {
      light: colors.blue[100],
      main: colors.blue[300],
      dark: colors.blue[500],
    },
    secondary: {
      light: colors.blue[100],
      main: colors.blue[300],
      dark: colors.blue[500],
    },
    success: {
      light: colors.green[100],
      main: colors.green[300],
      dark: colors.green[500],
    },
    info: {
      light: colors.blue[100],
      main: colors.blue[300],
      dark: colors.blue[500],
    },
    warning: {
      light: colors.orange[100],
      main: colors.orange[300],
      dark: colors.orange[500],
    },
    error: {
      light: colors.red[100],
      main: colors.red[300],
      dark: colors.red[500],
    },
    background: {
      default: colors.pitrho.dark.background.default,
      paper: colors.pitrho.dark.background.paper,
      header: colors.pitrho.dark.background.header
    },
    grey: gray,
  },
  typography: {
    ...qtmTypography,
  },
});